import React from "react";
import { Link } from "gatsby";
import styled from "styled-components";
import { Container } from "react-bootstrap";
import { ACCENT, ACCENT_DARK, ACCENT_TINT, INK, BODY, MUTED, LINE, SURFACE } from "./tokens";

export const Section = styled(({ bg, ...props }) => <section {...props} />)`
  padding: 72px 0;
  background: ${({ bg }) => bg === "ash" ? SURFACE : "#fff"};
  color: ${BODY};
  a:not([class]) { color: ${ACCENT}; text-decoration: underline; text-underline-offset: 3px; }
  @media (max-width: 767px) { padding: 48px 0; }
`;
export const Title = styled(({ variant, ...props }) => <h2 {...props} />)`
  color: ${INK}; font-weight: 700; line-height: 1.18;
  font-size: ${({ variant }) => variant === "card" ? "20px" : "30px"};
  letter-spacing: -.7px; margin: 0 0 16px;
`;
export const Text = styled.p`
  color: ${BODY}; font-size: 16px; line-height: 1.7; margin: 0 0 16px;
`;
export const ButtonLink = styled(Link)`
  display: inline-flex; justify-content: center; align-items: center;
  background: ${ACCENT}; color: #fff; border: 1px solid ${ACCENT};
  padding: 12px 22px; border-radius: 6px; font-size: 14px; font-weight: 600;
  text-decoration: none; min-height: 44px;
  &:hover { color: #fff; background: ${ACCENT_DARK}; text-decoration: none; }
  &:focus-visible { outline: 3px solid ${ACCENT}; outline-offset: 4px; }
  &[data-secondary="true"] { background: #fff; border-color: ${LINE}; color: ${INK}; }
  &[data-secondary="true"]:hover { background: ${ACCENT_TINT}; }
`;
export const Actions = styled.div`display: flex; flex-wrap: wrap; gap: 12px; margin-top: 26px;`;
const Intro = styled.section`
  padding: 26px 0 56px; background: ${SURFACE}; border-bottom: 1px solid ${LINE};
  h1 { color: ${INK}; font-size: 46px; line-height: 1.1; letter-spacing: -1.5px; max-width: 800px; margin: 28px 0 18px; }
  p { font-size: 18px; max-width: 760px; color: ${BODY}; line-height: 1.65; margin: 0; }
  nav { font-size: 13px; color: ${MUTED}; }
  nav a { color: ${MUTED}; }
  nav span { margin: 0 10px; }
  @media (max-width: 767px) { padding-bottom: 40px; h1 { font-size: 36px; } }
`;
export const PageIntro = ({ title, children }) => <Intro><Container>
  <nav aria-label="Breadcrumb"><Link to="/document-scanning/">Document scanning</Link><span aria-hidden="true">/</span>{title}</nav>
  <h1>{title}</h1><p>{children}</p>
  <Actions><ButtonLink to="/document-scanning/#quote">Get a quote</ButtonLink><ButtonLink data-secondary="true" to="/document-scanning/pricing/">See the price list</ButtonLink></Actions>
</Container></Intro>;
